import React from 'react';
import ReactDOM from 'react-dom/client';

// ----> REACT ROUTER DOM IMPORTATION
import { BrowserRouter } from "react-router-dom";

import App from './App';
import './index.css';

// ----> IMPORTATION FROM i18next
import { I18nextProvider } from "react-i18next";
import i18next from 'i18next';


// GET language app
import { LANGUAGE } from "./config/appConf.js";

// ----> IMPORTATIONS OF TRANSLATIONS
import global_spanish from "./translations/spanish/global.json";
import global_english from "./translations/english/global.json";


i18next.init({
  interpolation: { escapeValue: false },
  lng: LANGUAGE,
  resources: {
    es: {
      global: global_spanish
    },
    en: {
      global: global_english
    }
  }
});



const root = ReactDOM.createRoot(document.getElementById('app'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <I18nextProvider i18n={i18next}>
        <App />
      </I18nextProvider>
    </BrowserRouter>
  </React.StrictMode>
);


